import MouseCursor from "@/components/MouseCursor";
import { SVGCarouselPlus, SVGCarouselSwipe } from "@/lib/svg";
import styled, { css } from "styled-components";

export const Container = styled(MouseCursor as any)`
  display: none;
  ${({ theme }) => theme.mediaQueries.laptop} {
    background: ${({ theme }) => theme.colors.black};
    border-radius: 50%;
    display: grid;
    place-items: center;
    opacity: 0;
    transform: scale(0.75);
  }
`;

export const iconStyles = css`
  width: 42px;
  height: 42px;
`;

export const PlusIcon = styled(SVGCarouselPlus as any)`
  ${iconStyles}
`;
export const SwipeIcon = styled(SVGCarouselSwipe as any)`
  ${iconStyles}
`;
